/* eslint-disable import/order */
import { useByokComplianceSettingWithInitialisation } from '@jira/admin-pages__products-jsm-compliance/src/useByokComplianceSettingWithInitialisation.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useSummaryPageConfig } from '@jira/router-resources__service-desk-project-summary/src/useSummaryPageConfig.tsx';

export const useSummaryPageConfigAndByokData = (): {
	loading: boolean;
	isByokCustomer: boolean;
	isReportingEnabled: boolean | undefined;
} => {
	const { data: config, loading: configLoading } = useSummaryPageConfig();
	const {
		isByokCustomer,
		loading: byokLoading,
		error: byokError,
		data: byokData,
	} = useByokComplianceSettingWithInitialisation();

	const isByokFetchNotStarted =
		!byokLoading && !byokData && !byokError && fg('audit-logs-byok-encrypted-data');
	const loading = configLoading || byokLoading || isByokFetchNotStarted;

	return {
		loading,
		isByokCustomer,
		isReportingEnabled: config?.isReportingEnabled,
	};
};
